<template>
  <div class="page-content InventoryAdjustment">
    <h1 class="page-title">{{ $locale('sideMenu.reports.inventoryLog') }}</h1>

    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col :lg="12" :md="24">
        <DatePickerGroup
          v-bind:start="startTime"
          v-bind:end="endTime"
          @setFatherDate="getDate"
        ></DatePickerGroup>
      </el-col>
      <el-col class="ta-r" :lg="12" :md="24">
        <el-button
          class="egl-btn-yellow"
          @click="exportCSV"
        >{{ $locale("global.exportToCSV") }}</el-button>
        <el-button class="egl-btn-yellow" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col class="makeInline" :lg="8" :md="24">
        <el-input class="searchMaxWidth"
          :placeholder="$locale('inventoryLog.searchPlaceHolder')"
          v-model="searchValue"
          @keyup.enter.native="getList"
        >
          <i slot="suffix" class="el-input__icon el-icon-search" @click="getList(searchValue, sort, filterType, filters, curPage)"></i>
        </el-input>
        <el-button class="egl-btn-yellow makeLeft" @click="getList">{{
          $locale("global.search")
        }}</el-button>
      </el-col>
    </el-row>
    <hr class="dotted" />
    <div id="print">
      <el-table
      class="egl-table list-table"
      style="width: 100%"
      :data="tableData"
      :stripe="true"
      ref="tableRef"
      @sort-change="sortHandler"
      @filter-change="filter"
    >
			<el-table-column
				:column-key="item.columnKey && item.columnKey"
				v-for="(item, idx) in tableLabel"
				:key="idx"
				:label="item.label"
				:min-width="item.width"
				:prop="item.prop"
				:align="item.align"
				:sortable="item.sort ? 'custom' : false"
				:filters="item.filter && getFilterArr(item.filter)"
				:filtered-value="item.filter && getFilterValueArr(item.filter)"
        :formatter="item.formatter"
			></el-table-column>
		</el-table>
    </div>
    

    <CommPagination
      :total="count"
      :curPage="curPage"
      :pageSize="pageSize"
      @current-change="pageChange"
    />
	</div>
</template>
<style scoped>
.makeInline {
  white-space: nowrap;
}
.searchMaxWidth {
  margin-right: 5px;
  max-width: 350px;
}
.makeLeft {
  margin-left: 5px;
}
</style>


<script>
import "@/assets/style/inventory.less";
import DatePickerGroup from "@/components/DatePickerGroup";
import moment from "moment";
import CommPagination from "@/components/common/CommPagination";
import { priceFormat, getExportName_fn, weekLocaleArray } from "../../utils/common";
import {  getLogListService } from "@/helpers/service/api/inventory";
import {  getInventoryLogListService, inventoryLogExport } from "@/helpers/service/api/report";
import { getCinemaDailyListService } from "@/helpers/service/api/theaterDailyShow.js";

// const cinemaId = window.localStorage.getItem("cinemaId");
// let cinemaId;

function toThousands(num) {
  return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
}
export default {
  components: {
    CommPagination,
    DatePickerGroup,
  },
  created() {
    this.cinemaId = window.localStorage.getItem("cinemaId");
    // if (this.groupArr.length === 0) { this.getGroup(); }
    this.getList();
  },
  mounted() {
    getCinemaDailyListService({ cinemaId: window.localStorage.getItem("cinemaId") }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.groupArr = res.data.data.map(item => ({
          text: item.name,
          value: item.id
        }));
      }
    });
  },
  computed: {
    today() {
      return this.$moment().valueOf();
    }
  },
  data() {
    return {
      printObj: {
        popTitle: this.$locale('sideMenu.reports.inventoryLog'),
        id: "print"
      },
      cinemaId: "",
      startTime: new Date().valueOf(),
      endTime: new Date().valueOf(),
      searchValue: "",
      tableData: [],
      tableLabel: [
        {
          width: 180,
          label: this.$locale("inventoryLog.inventoryLogId"),
          prop: "inventoryLogId",
          align: "center",
        },
        {
          width: 180,
          label: this.$locale("global.date"),
          prop: "createTime",
          sort: true,
        },
        {
          width: 214,
          label: this.$locale("inventoryLog.actualDate"),
          prop: "actualDate",
        },
        {
          width: 160,
          label: this.$locale("inventoryLog.inventoryType"),
          prop: "inventoryType",
          filter: "salesType",
          columnKey: "inventoryType",
          align: "center",
        },
        {
          width: 120,
          label: this.$locale("inventoryLog.groupName"),
          prop: "cinemaDailySelective",
          filter: "group",
          columnKey: "cinemaDailySelective",
          align: "center",
          formatter: (row, column, cellValue) => {
            if (!cellValue) { return; }

            const _target = this.groupArr.find(_cds => _cds.id === cellValue) || {};
            return _target.name || cellValue;
          },
        },
        {
          width: 120,
          label: this.$locale("inventoryLog.productCode"),
          prop: "productCode",
          align: "center",
        },
        {
          width: 200,
          label: this.$locale("inventoryLog.name"),
          prop: "name"
        },
        {
          width: 150,
          label: this.$locale("inventoryLog.productType"),
          prop: "productType"
        },
        {
          width: 60,
          label: this.$locale("inventoryLog.unit"),
          prop: "unit",
          align: "center",
        },
        {
          width: 160,
          label: this.$locale("inventoryLog.stockPlace"),
          prop: "stockPlace"
        },
        {
          width: 160,
          label: this.$locale("inventoryLog.inventoryChangeType"),
          prop: "inventoryChangeType",
          filter: "type",
          columnKey: "inventoryChangeType",
          align: "center",
        },
        {
          width: 140,
          label: this.$locale("inventoryLog.stockQtyChanged"),
          prop: "stockQtyChanged",
          align: "center",
        },
        {
          width: 120,
          label: this.$locale("inventoryLog.stockChangeQty"),
          prop: "stockChangeQty",
          align: "center",
        },
        {
          width: 140,
          label: this.$locale("inventoryLog.stockQty"),
          prop: "stockQty",
          align: "center",
        },
        {
          width: 160,
          label: this.$locale("inventoryLog.stockPrice"),
          prop: "stockPrice",
        },
        {
          width: 160,
          label: this.$locale("inventoryLog.stockAmountChanged"),
          prop: "stockAmountChanged",
        },
        {
          width: 160,
          label: this.$locale("inventoryLog.stockChangeAmount"),
          prop: "stockChangeAmount"
        },
        {
          width: 160,
          label: this.$locale("inventoryLog.stockAmount"),
          prop: "stockAmount"
        },
        {
          width: 180,
          label: this.$locale("inventoryLog.changePeople"),
          prop: "changePeople"
        },
        {
          width: 300,
          label: this.$locale("inventoryLog.inventoryChangeSupplement"),
          prop: "inventoryChangeSupplement"
        }
      ],
      count: 0,
      salesArr: [
        {
          value: "commercial",
          text: this.$locale("inventoryLog.commercial")
        },
        {
          value: "ingredient",
          text: this.$locale("inventoryLog.ingredient")
        },
        {
          value: "concession",
          text: this.$locale("inventoryLog.concession")
        }
      ],
      salesIds: ["commercial", "ingredient", "concession"],
      typeArr: [
        {
          text: this.$locale("inventoryLog.getGoods"),
          value: "getGoods"
        },
        {
          text: this.$locale("inventoryLog.sellGoods"),
          value: "sellGoods"
        },
        {
          text: this.$locale("inventoryLog.refoundGoods"),
          value: "refoundGoods"
        },
        {
          text: this.$locale("inventoryLog.discardGoods"),
          value: "discardGoods"
        },
        {
          text: this.$locale("inventoryLog.otherGoods"),
          value: "otherGoods"
        },
        {
          text: this.$locale("inventoryLog.refoundGoodsFromCustomer"),
          value: "refoundGoodsFromCustomer"
        }
      ],
      typeIds: ["getGoods", "sellGoods", "refoundGoods", "discardGoods", "otherGoods", "refoundGoodsFromCustomer"],
      groupArr: [],
      groupIds: [],
      sort: "",
      filterType: "",
      filters: [],
      curPage: 0,
      pageSize: 10,
      dayList: [
        this.$locale("inventoryLog.sun"),
        this.$locale("inventoryLog.mon"),
        this.$locale("inventoryLog.tue"),
        this.$locale("inventoryLog.wed"),
        this.$locale("inventoryLog.thu"),
        this.$locale("inventoryLog.fri"),
        this.$locale("inventoryLog.sat"),
      ],
      saleType: {
        commercial: this.$locale("inventoryLog.commercial"),
        ingredient: this.$locale("inventoryLog.ingredient"),
        concession: this.$locale("inventoryLog.concession"),
      },
      type: {
        getGoods: this.$locale("inventoryLog.getGoods"),
        sellGoods: this.$locale("inventoryLog.sellGoods"),
        refoundGoods: this.$locale("inventoryLog.refoundGoods"),
        discardGoods: this.$locale("inventoryLog.discardGoods"),
        otherGoods: this.$locale("inventoryLog.otherGoods"),
        refoundGoodsFromCustomer: this.$locale("inventoryLog.refoundGoodsFromCustomer"),
      },
      productTypeOption: {
        SALES_ITEM: this.$locale("inventoryLog.SALES_ITEM"),
        CONSIGNMENT: this.$locale("inventoryLog.CONSIGNMENT"),
      },
    };
  },
  methods: {
    getList(searchValue, sort, filterType, filters, page) {
      const startDate = this.formatDate(this.startTime);
      const endDate = this.formatDate(this.endTime);

      getInventoryLogListService({
        cinemaId: this.cinemaId,
        ...page ? { page } : {},
        pageSize: this.pageSize,
        ...searchValue ? { searchName: this.searchValue } : {},
        ...sort ? { sort: sort } : {},
        ...filterType ? { typeName: filterType } : {},
        ...filters && filters.length > 0 ? { typeNameValueList: filters } : {},
        startDate,
        endDate,
      }).then(res => {
        // format Date
        let { data: { data, count } } = res;
        this.count = count || 0;

        // data.createTime = moment(data.createTime).format('YYYY-M-DD')
        data.forEach(data => {
          let day = this.dayList[new Date(data.createTime).getDay()];
          data.createTime = moment(data.createTime).format(`YYYY-M-DD (${day}) HH:mm`);
          data.actualDate = moment(data.actualDate).format(`YYYY-M-DD (${day})`);
          data.inventoryType = this.saleType[data.inventoryType];
          data.productType = this.productTypeOption[data.productType];
          data.inventoryChangeType = this.type[data.inventoryChangeType];
          data.stockQtyChanged = toThousands(data.stockQtyChanged);
          data.stockChangeQty = toThousands(data.stockChangeQty);
          data.stockQty = toThousands(data.stockQty);
          data.stockPrice = "¥ " + priceFormat(data.stockPrice, 2, "price");
          // data.stockAmountChanged = '¥' + priceFormat(data.stockAmountChanged, 2, 'price')
          if (data.stockAmountChanged < 0) {
            data.stockAmountChanged = parseInt(data.stockAmountChanged.toString().substr(1));
            data.stockAmountChanged = `¥ -${priceFormat(data.stockAmountChanged, 2, "price")}`;
          } else {
            data.stockAmountChanged = "¥ +" + priceFormat(data.stockAmountChanged, 2, "price");
          }
          if (data.stockChangeAmount < 0) {
            data.stockChangeAmount = parseInt(data.stockChangeAmount.toString().substr(1));
            data.stockChangeAmount = `¥ -${priceFormat(data.stockChangeAmount, 2, "price")}`;
          } else {
            data.stockChangeAmount = "¥ +" + priceFormat(data.stockChangeAmount, 2, "price");
          }
          if (data.stockAmount < 0) {
            data.stockAmount = parseInt(data.stockAmount.toString().substr(1));
            data.stockAmount = `¥ -${priceFormat(data.stockAmount, 2, "price")}`;
          } else {
            data.stockAmount = "¥ +" + priceFormat(data.stockAmount, 2, "price");
          }
        });
        this.tableData = data;
      });
    },
    getGroup() {
      getLogListService({ cinemaId: this.cinemaId }).then(res => {
        this.groupArr = res.data;
        this.groupArr.forEach(item => {
          item.value = item.id;
          item.text = item.name;
          this.groupIds.push(item.id);
        });
      });
    },
    pageChange(page) {
      this.curPage = page - 1;
      this.getList(this.searchValue, this.sort, this.filterType, this.filters, page - 1);
    },
    formatDate(timestamp) {
      return moment(timestamp).format("YYYY-MM-DD");
    },
    getDate(obj) {
      const { startDate, endDate } = obj || {};
      if (startDate) {
        this.startTime = startDate;
      }
      if (endDate) {
        this.endTime = endDate;
      }
    },
    search() {
      this.getList(this.searchValue, this.sort, this.filterType, this.filters, 0);
      // this.$refs["child"].$refs.page.internalCurrentPage = 1;
    },
    getFilterArr(type) {
      switch(type) {
      case "salesType":
        return this.salesArr;
      case "type":
        return this.typeArr;
      case "group":
        return this.groupArr;
      default:
        break;
      }
    },
    getFilterValueArr(type) {
      switch(type) {
      case "salesType":
        return this.salesIds;
      case "type":
        return this.typeIds;
      case "group":
        return this.groupIds;
      default:
        break;
      }
    },
    sortHandler(value) {
      let sort = value.order;
      if (sort === "descending") {
        sort = "DESC";
      } else if (sort === "ascending") {
        sort = "ASC";
      } else {
        sort = "";
      }
      this.sort = sort;
      this.getList(this.searchValue, this.sort, this.filterType, this.filters, this.curPage);
    },
    filter(value) {
      let keys = Object.keys(value);
      let [ type ] = keys;

      this.filterType = type;
      this.filters = value[type];
      this.getList(this.searchValue, this.sort, this.filterType, this.filters, 0);
      // this.$refs["child"].$refs.page.internalCurrentPage = 1;
    },
    exportCSV() {
      const startDate = this.formatDate(this.startTime);
      const endDate = this.formatDate(this.endTime);

      inventoryLogExport({
        cinemaId: this.cinemaId,
        startDate,
        endDate,
      }).then(res => {
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM
        const content = new TextEncoder().encode(res);
        const blob = new Blob([ bom, content ], { type: 'text/csv;charset=utf-8;' });
        const blobUrl = window.URL.createObjectURL(blob);
        const aElement = document.createElement("a");
        aElement.href = blobUrl;
        aElement.download = 
        // `${this.$moment().format("YYYYMMDDHHmm")}_${this.$locale("inventoryLog.title")}.csv`;
        getExportName_fn(
          this.$locale("inventoryLog.title"),
          '',
          '',
          '',
          `${this.$moment(startDate).format('YYYY-MM-DD')} （${weekLocaleArray[this.$moment(startDate).day()]}）~ ${this.$moment(endDate).format('YYYY-MM-DD')} （${weekLocaleArray[this.$moment(endDate).day()]}）`,
          '',
          this.$moment().format('YYYYMMDDHHmm')
        ) + '.csv'
        aElement.click();
        window.URL.revokeObjectURL(blobUrl);
      });
    }
  }
};
</script>
